import { render } from "./FormSection.vue?vue&type=template&id=48e651fe&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"

import "./FormSection.vue?vue&type=style&index=0&id=48e651fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48e651fe"

export default script